import { DefaultFooter } from './DefaultFooter';
import { DefaultHeader } from './DefaultHeader';

export default ({
  DefaultFooter,
  DefaultHeader
})
